import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-dpe-ges',
  templateUrl: './dpe-ges.component.html',
  styleUrls: ['./dpe-ges.component.scss']
})
export class DpeGesComponent implements OnInit {

  @Input() dpeDate: any;
  @Input() dpeValue: number | null = null;
  @Input() dpeLettre: string = "";
  @Input() gesValue: number | null = null;
  @Input() gesLettre: string = "";
  letter: string = '';
  letter_list = ['a', 'b', 'c', 'd', 'e', 'f', 'g'];
  options = {
    label_dpe_none: 'DPE non communiqué',
    label_ges_none: 'GES non communiqué',
    label_mini: 'Bâtiment économe',
    label_ges_min: 'Faible émission de GES*',
    label_maxi: 'Bâtiment énergivore',
    label_ges_max: 'Forte émission de GES*',
    label_legend: 'en kWh/m².an',
    label_legend_ges: '* Gaz à effet de serre en KgeqCO2/m².an',
    image_dir: '/assets/images/',
    height: 26,
    width: 330,
    width2: 171,
  };
  constructor() { }

  ngOnInit(): void {

  }

  getDpeLetter(): string {
    let letter = '';
    if(this.dpeLettre){
      letter = this.dpeLettre;
    } else if (this.dpeValue !== null) {
      if (this.dpeValue <= 50) {
        letter = 'a';
      } else if (this.dpeValue <= 90) {
        letter = 'b';
      } else if (this.dpeValue <= 150) {
        letter = 'c';
      } else if (this.dpeValue <= 230) {
        letter = 'd';
      } else if (this.dpeValue <= 330) {
        letter = 'e';
      } else if (this.dpeValue <= 450) {
        letter = 'f';
      } else {
        letter = 'g';
      }
    }
    return letter;
  }

  getDpeImagePath(lettre: string): string {
    const prefix = 'dpe-';
    const suffix = '.png';
    const selected_token = '-v';
    const isSelected = this.checkLettreDpe(lettre);
    return `${this.options.image_dir}/dpe/${prefix}${lettre}${isSelected ? '' : selected_token}${suffix}`;
  }

  checkLettreDpe(lettre: string){
    return lettre.toLowerCase() === this.getDpeLetter().toLowerCase()
  }

  getGesLetter(): string {
    let letter = '';
    if (this.gesValue !== null) {
      if (this.gesValue <= 5) {
        letter = 'a';
      } else if (this.gesValue <= 10) {
        letter = 'b';
      } else if (this.gesValue <= 20) {
        letter = 'c';
      } else if (this.gesValue <= 35) {
        letter = 'd';
      } else if (this.gesValue <= 55) {
        letter = 'e';
      } else if (this.gesValue <= 80) {
        letter = 'f';
      } else {
        letter = 'g';
      }
    }
    return letter;
  }

  getGesImagePath(lettre: string): string {
    const prefix = 'ges-';
    const suffix = '.png';
    const selected_token = '-v';
    const isSelected = this.checkLettreGes(lettre);
    return `${this.options.image_dir}/ges-couleur/${prefix}${lettre}${isSelected ? '' : selected_token}${suffix}`;
  }

  checkLettreGes(lettre: string){
    return lettre.toLowerCase() === this.getGesLetter().toLowerCase()
  }

}
